export default "__VITE_ASSET__efdf2622__"